export default __webpack_public_path__ + "static/media/68_desktop.cba7d280.jpg";